import React, { useState } from "react";
import { Button, Input, Modal, Typography, Row, Col } from "antd";

const { TextArea } = Input;
const { Title } = Typography;

const ProblemForm = () => {
  const [problemTitle, setProblemTitle] = useState("");
  const [htmlProlem, setHtmlProlem] = useState(`<div>
กำหนด Array 1 มิติ ประกอบด้วยตัวเลข N จำนวน เกมนี้ผู้เข้าแข่งขัน
ต้องเขียนโปรแกรม<b><u>ที่มีประสิทธิภาพ</u></b>หา Array ย่อยที่ให้ค่าผลรวมมากที่สุด<br><br>
<b><u>ข้อมูลนำเข้า</u></b><br>
บรรทัดที่ 1 คือจำนวนตัวเลขใน Array (N) โดยที่ 1 &le; N &le; 10<sup>5</sup><br>
บรรทัดที่ 2 คือชุดตัวเลขใน Array (A<sub>i</sub>) โดยที่ -10,000 &le; A<sub>i</sub> &le; 10,000<br><br>
<b><u>ข้อมูลส่งออก</u></b><br>
ผลรวมของ Array ย่อยที่มากที่สุด<br><br>

<b><u>คำอธิบายข้อมูลทดสอบที่ 1</u></b><br>
<p>Array ย่อยคือ [4,-1,2,1] ซึ่งให้ค่าผลรวมมากที่สุดเท่ากับ 6</p>
</div>
    `)
  const [htmlSample, setHtmlSample] = useState(`<tr>
 <th>ข้อมูลนำเข้า</th>
 <th>ข้อมูลส่งออก</th>
</tr>
<tr>
 <td>
2-1-1<br>
  </td>
  <td>
0 2
  </td>
 </tr>
    `)

  const showSuccessModal = (message) => {
    Modal.success({
      title: "Success",
      content: message,
    });
  };

  const showErrorModal = (message, statusCode) => {
    Modal.error({
      title: `Error ${statusCode}`,
      content: message,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    if (!problemTitle || !htmlSample || !htmlProlem) {
      Modal.error({
        title: "Error",
        content: "All fields are required.",
      });
      return;
    }

    formData.append("problem_name", problemTitle);
    formData.append("html_problem", htmlProlem);
    formData.append("html_sample", htmlSample);
    formData.append("maxscore", 50);


    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/problem`,
        {
          method: "POST",
          body: formData,
          headers: {
            "x-access-token": localStorage.getItem("token"),
          },
        }
      );

      if (res.status === 200 || res.status === 201) {
        const text = await res.text();
        showSuccessModal(`Problem created successfully: ${text}`);

        setProblemTitle("");
        setHtmlProlem("");
        setHtmlSample("");
      } else {
        const errorMessage = await res.text();
        showErrorModal(errorMessage, res.status);
      }
    } catch (error) {
      showErrorModal("An error occurred while submitting the problem.", 500);
    }

  };

  return (
    <div style={{ width: "100%", margin: "0 auto", padding: "20px" }}>
      <Title level={3}>Create a Problem</Title>
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: "16px" }}>
          <label>
            <strong>Problem Title</strong>
          </label>
          <Input
            name="problem_name"
            placeholder="Enter the problem title"
            value={problemTitle}
            onChange={(e) => setProblemTitle(e.target.value)}
            required
          />
        </div>

        <Row gutter={16}>
          <Col span={12}>
            <div style={{ marginBottom: "16px" }}>
              <label>
                <strong>HTML Problem</strong>
              </label>
              <TextArea
                name="html_problem"
                placeholder="Enter a sample HTML Problem"
                rows={40}
                value={htmlProlem}
                onChange={(e) => setHtmlProlem(e.target.value)}
                required
              />
            </div>
          </Col>

          <Col span={12}>
            <div style={{ marginBottom: "16px" }}>
              <label>
                <strong>HTML Sample</strong>
              </label>
              <TextArea
                name="html_sample"
                placeholder="Enter user HTML Sample"
                rows={40}
                value={htmlSample}
                onChange={(e) => setHtmlSample(e.target.value)}
                required
              />
            </div>
          </Col>
        </Row>

        <Button type="primary" htmlType="submit" block>
          Submit Problem
        </Button>
      </form>
    </div>
  );
};

export default ProblemForm;
